export default function ({ $axios, error, $toast }) {}
